import { envDomain } from '@/common/contact-selector/utils/domainConfig';
import convertList from '../convertList';
// import filters from '../filters';
// import sign from '../sign';

function searchGQQFriendByName(params) {
    return Vue.prototype.$_sAjax.crossGet(`${envDomain.gateway}/b2b/selector/searchQQFriendByName`, {
        params
    });
}

export default function(params) {
    return new Promise((resolve, reject) => {
        searchGQQFriendByName(params).then(
            res => {
                if (window.parseInt(res.code) === 0 && res.data) {
                    if (!res.data.friends) {
                        resolve({
                            list: []
                        });
                        return;
                    }
                    for (let i = 0; i < res.data.friends.length; i += 1) {
                        if (typeof res.data.friends[i].uin === 'number') {
                            res.data.friends[i].uin += '';
                        }
                        res.data.friends[i].id += res.data.friends[i].uin;
                    }
                    let newList = convertList(res.data.friends);
                    newList = newList.map(originItem => {
                        const item = originItem;
                        // 私有备注优先级最高
                        item.name = item.privateRemark || item.name;
                        return item;
                    });
                    // 个Q不需要设置主号等相关信息
                    resolve({
                        list: newList
                    });
                    // filters.setKfuinTypeInList(newList).then(resList => {
                    //     resolve({
                    //         list: resList
                    //     });
                    // });
                } else {
                    reject(res);
                }
            },
            err => {
                reject(err);
            }
        );
    });
}
